import Swal from "sweetalert2";
import "../css/swal.css";

class SweetAlertService {
  static showLoading(title) {
    return Swal.fire({
      title: title,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  static close(swalert) {
    if (swalert) {
      swalert.close();
    }
  }

  errorMsg(title, text) {
    return Swal.fire({
      icon: "error",
      title: title,
      text: text,
      confirmButtonColor: "#009188",
    });
  }

  successMsg(title) {
    return Swal.fire({
      icon: "success",
      title: title,
      showConfirmButton: false,
      timer: 1700,
    });
  }
}

export default SweetAlertService;
